import { Facebook, Instagram, Youtube, Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { buildSocialUrl } from '@/lib/social-links';
import { trackFollowClick } from '@/lib/follow-prompt';

export function FooterFollowBlock() {
  return (
    <div className="border-t border-primary-foreground/10 mt-6 pt-6">
      <div className="max-w-2xl mx-auto text-center">
        <h4 className="font-semibold mb-1 flex items-center justify-center gap-2">
          <Heart className="w-4 h-4 text-accent" aria-hidden="true" />
          Følg med — vi er kun lige startet
        </h4>
        <p className="text-sm text-primary-foreground/70 mb-3">
          Vi deler nye elbiler, priser og tips i ugens løb. Følg os — det betyder alt for et lille dansk site som vores.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button
            asChild
            variant="accent"
            className="gap-2"
            onClick={() => trackFollowClick('facebook', 'footer')}
          >
            <a href={buildSocialUrl('facebook', 'footer')} target="_blank" rel="noopener noreferrer" aria-label="Følg Min Nye Elbil på Facebook">
              <Facebook className="w-4 h-4" /> Facebook
            </a>
          </Button>
          <Button
            asChild
            variant="accent"
            className="gap-2"
            onClick={() => trackFollowClick('instagram', 'footer')}
          >
            <a href={buildSocialUrl('instagram', 'footer')} target="_blank" rel="noopener noreferrer" aria-label="Følg Min Nye Elbil på Instagram">
              <Instagram className="w-4 h-4" /> Instagram
            </a>
          </Button>
          <Button
            asChild
            variant="accent"
            className="gap-2"
            onClick={() => trackFollowClick('youtube', 'footer')}
          >
            <a href={buildSocialUrl('youtube', 'footer')} target="_blank" rel="noopener noreferrer" aria-label="Følg Min Nye Elbil på YouTube">
              <Youtube className="w-4 h-4" /> YouTube
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
